import React from 'react';
import { ZoomIn, ZoomOut, Grid, Download, Save, Upload, Eye } from 'lucide-react';
import { BannerSize } from '../types';

interface ToolbarProps {
  currentSize: BannerSize;
  sizes: BannerSize[];
  zoom: number;
  showGrid: boolean;
  onSizeChange: (size: BannerSize) => void;
  onZoomChange: (zoom: number) => void;
  onToggleGrid: () => void;
  onExport: () => void;
  onSave: () => void;
  onLoad: () => void;
  onPreview: () => void;
  hasDataFeed: boolean;
}

export const Toolbar: React.FC<ToolbarProps> = ({
  currentSize,
  sizes,
  zoom,
  showGrid,
  onSizeChange,
  onZoomChange,
  onToggleGrid,
  onExport,
  onSave,
  onLoad,
  onPreview,
  hasDataFeed
}) => {
  return (
    <div className="bg-white border-b border-gray-200 p-4 flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">Size:</label>
          <select
            value={currentSize.id}
            onChange={(e) => {
              const size = sizes.find(s => s.id === e.target.value);
              if (size) onSizeChange(size);
            }}
            className="px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {sizes.map(size => (
              <option key={size.id} value={size.id}>
                {size.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center space-x-2">
          <button
            onClick={() => onZoomChange(Math.max(0.25, zoom - 0.25))}
            className="p-1 hover:bg-gray-100 rounded"
            title="Zoom Out"
          >
            <ZoomOut size={18} />
          </button>
          <span className="text-sm text-gray-600 min-w-[60px] text-center">
            {Math.round(zoom * 100)}%
          </span>
          <button
            onClick={() => onZoomChange(Math.min(2, zoom + 0.25))}
            className="p-1 hover:bg-gray-100 rounded"
            title="Zoom In"
          >
            <ZoomIn size={18} />
          </button>
        </div>

        <button
          onClick={onToggleGrid}
          className={`p-2 rounded ${showGrid ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'}`}
          title="Toggle Grid"
        >
          <Grid size={18} />
        </button>
      </div>

      <div className="flex items-center space-x-2">
        {hasDataFeed && (
          <button
            onClick={onPreview}
            className="flex items-center space-x-2 px-3 py-2 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded border border-blue-200"
          >
            <Eye size={16} />
            <span className="text-sm">Preview All</span>
          </button>
        )}
        <button
          onClick={onLoad}
          className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:bg-gray-100 rounded"
        >
          <Upload size={16} />
          <span className="text-sm">Load</span>
        </button>
        <button
          onClick={onSave}
          className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:bg-gray-100 rounded"
        >
          <Save size={16} />
          <span className="text-sm">Save</span>
        </button>
        <button
          onClick={onExport}
          className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          <Download size={16} />
          <span className="text-sm">Export</span>
        </button>
      </div>
    </div>
  );
};